<div class="row ss-top-menu">
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i
        class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">CM- DGM Mapping</span>
  </div>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 d-flex align-items-center"> 
    <span style="width: 122px;">Filter by DGM </span>
    <ng-select (change)="filterbyasm($event)" style="width: 100%;" class="downloadBtn filter-status"  placeholder="Select DGM" >
      <ng-option selected value="">All</ng-option>
      <ng-option *ngFor="let dgms of get_dgm_list" value="{{dgms.id}}">{{dgms.name}}</ng-option>
    </ng-select>
</div>
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 align-self-center">
    <input class="form-control mr-sm-2" type="text" [(ngModel)]="searchItem" placeholder="Name/ Email ID"
      style="font-size: 12px;">
  </div>
  <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 px-0 align-self-center">
    <button class="searchBtn" (click)="listingDgmLeads(searchItem)">Search</button>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="tableDiv table-responsive">
      <p *ngIf="DgmLeads && DgmLeads.length === 0" class="text-center">No Leads Available</p>
      <table class="table" *ngIf="DgmLeads && DgmLeads.length > 0">
        <thead>
          <tr>
            <th class="firstTh">#</th>
            <th class="addCursor">Name</th>
            <th>Contact</th>
            <th>Email</th>
            <th>Last Status Update</th>
            <th> Assigned DGM</th>
            <th> Assigne DGM</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dgm of DgmLeads, let i = index;" [attr.data-index]="i">
            <td>{{i+1}}</td>
            <td class="minWidthForTd capitalize">{{dgm.name}}</td>
            <td class="minWidthForTd">{{dgm.contact}}</td>
            <td class="minWidthForTd">{{dgm.email}}</td>
            <td class="minWidthForTd">{{dgm.update_at | date:'dd MMM, y , h:mm a'}}</td>
            <td class="minWidthForTd">{{dgm.dgm}}</td>

            <td class="minWidthForTd text-center">
              <select class="form-control" (change)="onDropdownChange(dgm.id,$event.target.value,i)"
                id="assigndropdown{{dgm.id}}"  style="width: 77%; display: inline-block;font-size: 14px;">
                <option>Assign To DGM</option>
                <ng-container *ngFor="let dg of get_dgm_list" >
                  <option  value={{dg.id}} >{{dg.name}} - {{dg.email}} </option>
                </ng-container>        
              </select>
              <img src="assets/v3/img/sendbutton1.svg" class="ml-1 sendIcon addCursor"
                (click)="assignDGMToCM(dgm.id,i)">
            </td>


            <td class="text-center">
              <i *ngIf ="dgm.dgm" data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash addCursor"
                aria-hidden="true" data-toggle="modal" data-target="#deleteAsm"
                (click)="getDataofRemoveASM( dgm.id )"></i>
            </td>


          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div class="modal" id="deleteAsm">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Remove Deputy General Manager</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Do you want to remove assigned Deputy General Manager
      </div>

      <!-- Modal footer -->
      <div class="modal-footer border-0">
        <button type="button" class="btn searchBtn" (click)="removeASM()">Yes</button>
        <button type="button" class="btn searchBtn" data-dismiss="modal">No</button>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-dgm-mapping/cm-dgm-mapping.component.html